import { SettingsService } from '@settings/services/settings.service';
import { SETTINGS_STORE } from '@settings/stores/settings.store';

export const SETTINGS_PROVIDERS = [SettingsService, SETTINGS_STORE];
